<ng-container [formGroup]="formGroup">
  <div class="section">
    <pdq-heading element="h5">Token for Shopify</pdq-heading>
    <div class="controls-wrapper">
      <pdq-link
        label="View detailed installation instructions"
        [external]="true"
        [url]="'https://support.prettydamnquick.com/en/articles/8560867-adding-multiple-pdq-components'"></pdq-link>
      <pdq-input
        [disabled]="true"
        [formControl]="formGroup.get('usageToken')"
        label="Copy & paste this into Shopify's Components by 'Upgrade token'"
        [clipboard]="true"></pdq-input>
      <pdq-extension-preview-token [usageTokenControl]="formGroup.get('usageToken')"></pdq-extension-preview-token>
    </div>
  </div>

  <div class="section">
    <pdq-heading element="h5">General</pdq-heading>
    <div class="controls-wrapper">
      <pdq-input [formControl]="formGroup.get('internalName')" label="Internal name"></pdq-input>
    </div>
  </div>

  <div class="section" formGroupName="settings">
    <pdq-heading element="h5">Upgrade Configuration</pdq-heading>
    <div class="controls-wrapper">
      <div class="radio">
        <div class="radio__title">Display Mode</div>
        <pdq-radio-group formControlName="displayMode">
          @for (option of displayModeOptions; track option.value) {
            <pdq-radio-button
              [value]="option.value"
              [checked]="formGroup.get('settings.displayMode')?.value === option.value"
              [text]="option.text"
              [subText]="option.description">
            </pdq-radio-button>
          }
        </pdq-radio-group>
      </div>

      @if (isStandaloneBlock) {
        <div class="radio">
          <div class="radio__title">Layout style</div>
          <div class="option-cards">
            @for (option of layoutStyleOptions; track option.value) {
              <div
                class="option-card"
                [class.option-card--selected]="layoutStyle === option.value"
                (click)="selectLayoutStyle(option.value)">
                <div
                  class="option-card__radio"
                  [class.option-card__radio--checked]="layoutStyle === option.value"></div>
                <div class="option-card__content">
                  <span class="option-card__title">{{ option.text }}</span>
                  <span class="option-card__description">{{ option.description }}</span>
                </div>
              </div>
            }
          </div>
        </div>
      }

      @if (!isFocusedLayout) {
        <div class="radio">
          <div class="radio__title">Variant Selector</div>
          <pdq-radio-group formControlName="variantSelector">
            @for (option of variantSelectorOptions; track option.value) {
              <pdq-radio-button
                [value]="option.value"
                [checked]="formGroup.get('settings.variantSelector')?.value === option.value"
                [text]="option.label"
                [subText]="option.helpText">
              </pdq-radio-button>
            }
          </pdq-radio-group>
        </div>

        <pdq-divider></pdq-divider>

        <pdq-checkbox
          formControlName="allowRevert"
          label="Allow Users To Revert The Upgrade Action"
          secondaryLabel="When enabled, customers can undo an upgrade and return to the original product."
          labelSize="small">
        </pdq-checkbox>
        @if (formGroup.get('settings.allowRevert')?.value) {
          <div class="revert-label-field">
            <pdq-input formControlName="revertButtonLabel" label="Revert Button Label"></pdq-input>
          </div>
        }
      }

      <div class="allow-subscriptions">
        <div class="allow-subscriptions__header">
          <span class="allow-subscriptions__title">Allow Subscriptions</span>
          <pdq-slide-toggle formControlName="allowSubscriptions" togglePosition="right"></pdq-slide-toggle>
        </div>

        @if (allowSubscriptions) {
          <pdq-divider></pdq-divider>

          <div class="allow-subscriptions__content">
            <div class="allow-subscriptions__group">
              <div class="toggle-group">
                @for (option of subscriptionFrequencyOptions; track option.value) {
                  <button
                    type="button"
                    (click)="selectSubscriptionFrequency(option.value)"
                    [class.active]="subscriptionFrequency === option.value">
                    {{ option.text }}
                  </button>
                }
              </div>
            </div>

            @if (isStrictFrequency) {
              <div class="allow-subscriptions__group">
                <span class="allow-subscriptions__subtitle">Preserve Subscription Properties</span>
                <p class="allow-subscriptions__hint">
                  Keep the same frequency (e.g., every month) for the upgraded product.
                </p>
              </div>
              <div class="allow-subscriptions__group">
                <span class="allow-subscriptions__subtitle">If the same plan isn't available</span>
                <pdq-radio-group formControlName="noMatchingPlanBehavior">
                  @for (option of noMatchingPlanOptions; track option.value) {
                    <pdq-radio-button
                      [value]="option.value"
                      [checked]="noMatchingPlanBehavior === option.value"
                      [text]="option.text"
                      [subText]="option.description"
                      [tooltip]="option.value === 'useFirstAvailable' ? useFirstAvailableTooltip : null">
                    </pdq-radio-button>
                  }
                </pdq-radio-group>
              </div>
            } @else {
              <div class="allow-subscriptions__group">
                <span class="allow-subscriptions__subtitle">Manual Plan Selection</span>
                <p class="allow-subscriptions__hint">
                  Choose each product's subscription plans in the Product Selection tab. Only selected plans appear at
                  checkout, and the shopper's current plan is pre-selected when available. No plans, or none selected,
                  means a one-time purchase.
                </p>
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>
</ng-container>
